"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlternativeNames = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const AudioButton_1 = __importDefault(require("../../atoms/AudioButton"));
const styled_components_1 = __importDefault(require("styled-components"));
function AlternativeNames({ name, alternativeNames, onClickAudio, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const isLower = (0, ui_1.useScreenBreakpoint)(ui_1.sizeMainScreen.tablet);
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'AlternativeNames_Container', children: [(0, jsx_runtime_1.jsxs)(Header, { "data-e2e": 'AlternativeNames_Header', children: [(0, jsx_runtime_1.jsx)(HeaderText, { "data-e2e": 'AlternativeNames_HeaderText', children: name }), onClickAudio && isLower && ((0, jsx_runtime_1.jsx)(StyledAudioButton, { onClick: onClickAudio, "data-e2e": 'AlternativeNames_StyledAudioButton' }))] }), (0, jsx_runtime_1.jsx)(SubHeader, { "data-e2e": 'AlternativeNames_SubHeader', children: t(i18n_1.Strings.infoBox.altNames) }), (0, jsx_runtime_1.jsx)(List, { "data-e2e": 'AlternativeNames_List', children: alternativeNames.map(alternativeName => ((0, jsx_runtime_1.jsx)(ListItem, { "data-e2e": 'AlternativeNames_ListItem', children: alternativeName }, alternativeName))) })] }));
}
exports.AlternativeNames = AlternativeNames;
const Header = styled_components_1.default.div `
  display: flex;

  margin-top: 8px;
`;
const HeaderText = styled_components_1.default.div `
  font-size: 20px;
  line-height: 24px;
  font-weight: 700;
`;
const StyledAudioButton = (0, styled_components_1.default)(AudioButton_1.default) `
  margin-left: 16px;
  padding: 0;
`;
const SubHeader = styled_components_1.default.div `
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 700;
`;
const List = styled_components_1.default.ul `
  display: flex;
  flex-direction: column;

  margin-top: 0;
  padding: 0 0 0 26px;

  gap: 8px;
`;
const ListItem = styled_components_1.default.li `
  font-size: 16px;
  line-height: 22.4px;
  font-weight: 400;

  padding: 0;
`;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  gap: 8px;

  color: ${({ theme }) => theme.white};
`;
